const AnalyzerBusyToast = () => {
    return (
        <div style={{ 
            display: 'flex', 
            flexDirection: 'row', 
            alignItems: 'center',
            justifyContent: 'flex-start', 
            backgroundColor: '#FFF4E5',
            borderRadius: '4px !important',
            width: '100%',
        }}>
            <div style={{ textAlign: 'left' }}> 
                <strong style={{ 
                    fontSize: '16px', 
                    color: '#CE0E0E',
                    fontFamily: 'Jost'
                }}>Bugcount analyzer is busy</strong>
                <p style={{ 
                    fontSize: '14px', 
                    color: '#CE0E0E',
                    fontFamily: 'Jost'
                }}>Press the back button to return to the home screen, then try to connect again.</p>
            </div>
        </div>
    );
};

export default AnalyzerBusyToast;
